import React from "react";
import { Droplet } from "lucide-react";
import { useTranslation } from "react-i18next";
import SkinProfilePicker from "./SkinProfilePicker";

/**
 * SkinProfileCard — Settings entry point. Sits below the Allergens
 * card so users see related profile fields together. Heading + intro
 * copy localized via i18n; the picker itself self-localizes via its
 * own `t()` lookups.
 */
const SkinProfileCard = () => {
  const { t } = useTranslation();
  return (
    <div
      className="bg-white/80 backdrop-blur-xl border border-[#EADDD7] rounded-3xl p-7 soft-shadow mb-5"
      data-testid="skin-profile-card"
    >
      <div className="flex items-start gap-4 mb-5">
        <div className="shrink-0 h-11 w-11 rounded-full bg-[#F2E8E9] flex items-center justify-center">
          <Droplet className="h-5 w-5 text-[#9B6A6C]" />
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-medium text-[#2C2123] leading-tight mb-1">
            {t("onboarding.steps.skinTitle")}
          </h3>
          <p className="text-sm text-[#5C4B51] max-w-xl">
            {t("onboarding.steps.skinSubtitle")}
          </p>
        </div>
      </div>

      <SkinProfilePicker mode="settings" />
    </div>
  );
};

export default SkinProfileCard;
